import React from "react";
import { useUserContext } from "context/UserContext";
import CreditsSP from "layouts/SP/credit";

function Credits() {
  const { role } = useUserContext() || {};
  if (role === "SP") {
    return <CreditsSP />;
  }
  return null;
}

export default Credits;
